import { Dashboard } from "./Dashboard";

export const MobileDashboard = () => <Dashboard />;
